module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/axios/index.js
// module id = 15
// module chunks = 69